// extracted by mini-css-extract-plugin
export default {"container":"GameBalances_container__-CMJg","bottomRow":"GameBalances_bottomRow__LEA1z","balance":"GameBalances_balance__QMAaC","icon":"GameBalances_icon__BES+B"};